module.exports = __webpack_public_path__ + "static/img/red_envelope.3f43440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red_envelope.png
// module id = TBOH
// module chunks = 1